





























import { Component, Mixins, Prop } from 'vue-property-decorator'
import CoresDoPainel from './CoresDoPainel'
import DialogoDeMixETopPecas from './DialogoDeMixETopPecas.vue'
import MixDeCategorias from './MixDeCategorias.vue'
import TopPecas from './TopPecas.vue'
import type { MixETopPecasDoCliente } from '@/models'
import { buscarMixETopPecas } from '@/api/painelDoCliente'
import { criarCachePorTempo } from '@/shareds/cache-por-tempo'
import { deveMostrarVerMais } from '@/shareds/painel-do-cliente-mix-shareds'

const DOIS_MINUTOS_EM_MS = 2 * 60 * 1000

const buscarMixETopPecasComCache = criarCachePorTempo<MixETopPecasDoCliente>(DOIS_MINUTOS_EM_MS)

@Component({
	components: {
		DialogoDeMixETopPecas,
		MixDeCategorias,
		TopPecas,
	},
})
export default class MixETopPecasNoCaixa extends Mixins(CoresDoPainel) {
	@Prop({ type: String, required: true }) clienteId!: string
	@Prop({ type: String, required: true }) lojaId!: string

	dados: MixETopPecasDoCliente | null = null
	carregando = true
	mostrarDialogo = false

	get categorias() {
		return this.dados?.categorias || []
	}

	get topPecas() {
		return this.dados?.topPecas || []
	}

	get mostrarVerMais() {
		return deveMostrarVerMais(this.categorias, this.topPecas)
	}

	created() {
		this.carregar()
	}

	async carregar() {
		this.carregando = true
		try {
			this.dados = await buscarMixETopPecasComCache(
				`${this.clienteId}:${this.lojaId}`,
				() => buscarMixETopPecas(this.clienteId, this.lojaId),
			)
		} catch (erro) {
			console.warn('Falha ao buscar o mix de categorias e as top peças do cliente', erro)
			this.dados = null
		} finally {
			this.carregando = false
		}
	}
}
